import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'

class TeamsFirstStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  render() {
    const { className } = this.props

    return (
      <div className={className}>
        <img
          src={`${STATIC_BASE_URL}/static/webapp/images/settings/teams-first-step.png`}
          style={{ width: '313px', height: '474px' }}
        />
        <div className="actions-container">
          <div className="mt">
            <div className="number-indication">1</div>
            <span className="text-indication">
              Open Teams app and choose a channel where the integration will run.
            </span>
          </div>
          <div className="mt">
            <div className="number-indication">2</div>
            <span className="text-indication">
              From any channel's 3-dot menu, select{' '}
              <span style={{ fontWeight: 'bold' }}>Workflows</span>
            </span>
          </div>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="teams-backButton"
          />
          <Button
            text="Next Step"
            onClick={() => this.handleStepRedirect(1)}
            className="sml"
            id="teams-nextButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(TeamsFirstStep)`
  .buttons-container {
    margin-top: 80px;
  }
`
